import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import config from '../../../config';

import {
	CallbackResponse,
	saveTokens,
} from '../../basic/callback/Callback.hooks';
import { AppContext } from '../../../App.context';
import { clearTokens } from '../../../templates/basic/auth/Auth.hooks';

export function useCallback(): CallbackResponse {
	const [searchParams] = useSearchParams();
	const [url, setUrl] = useState('');

	const { kv, clearCache } = useContext(AppContext);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);
	const code = searchParams.get('code');

	useEffect(() => {
		if (!code) {
			setError(new Error('Missing code'));
			setIsLoading(false);
			return;
		}

		const redirecUrl = [
			location.protocol,
			'//',
			location.host,
			location.pathname,
		].join('');

		const params = new URLSearchParams({
			code: `${code}`,
			redirect_uri: redirecUrl,
		});

		const authUrl = [
			config.build.host,
			'/a360/magshop/authorize',
			'?',
			params.toString(),
		].join('');

		fetch(authUrl, {
			method: 'GET',
			headers: {
				'app-key': config.build.appKey,
				'Content-Type': 'application/json',
			},
		})
			.then((r) => r.json())
			.then((r) => {
				kv.clear();
				clearTokens();
				saveTokens(r);
				setUrl('/')
				setIsLoading(false);
			})
			.catch((e) => {
				setError(e);
				setUrl('/')
				setIsLoading(false);
			});
	}, [code]);
	return {
		isLoading,
		error,
		url
	};
}
